import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { Label } from "@progress/kendo-react-labels";
import { Component } from "react";
import { selectedAutomationNode } from "../../Template/NewTemplateSignals";

export class ValueProperty extends Component {
  constructor({ value, handlePropertyChange }) {
    super();
    this.state = {
      value: value,
    };
    this.handlePropertyChange = handlePropertyChange;
  }

  render() {
    return (
      <div
        key={`${selectedAutomationNode.value.options.id}`}
        className="k-my-2 k-mx-2"
      >
        <Label style={{ fontSize: "14px", fontWeight: "600" }}>Value:</Label>
        <Editor
          className="!k-w-full"
          value={this.state.value}
          onChange={(e) => this.setState({ value: e.html })}
          tools={[
            [
              EditorTools.OrderedList,
              EditorTools.UnorderedList,
              EditorTools.Indent,
              EditorTools.Outdent,
            ],
          ]}
          contentStyle={{
            height: 100,
          }}
          resizable={true}
          onBlur={() => {
            this.handlePropertyChange({
              e: { target: { value: this.state.value } },
              propertyName: "Value",
            });
          }}
          defaultEditMode="div"
        />
      </div>
    );
  }
}
